import { MediaControl } from "./MediaControl";
import { ConfigSection, SegmentedSetting } from "./MediaSettings";
import { useTranslation } from "react-i18next";

const FRAME_RATE_VALUES = [
  { value: "15", label: "15 FPS", nativeLabel: "15 fps" },
  { value: "30", label: "30 FPS", nativeLabel: "30 fps" },
  { value: "60", label: "60 FPS", nativeLabel: "60 fps" },
];

export function CameraControl() {
  const { t } = useTranslation();
  const resolutionOptions = [
    { value: "720", label: "720p", nativeLabel: "1280 × 720" },
    { value: "1080", label: "1080p", nativeLabel: "1920 × 1080" },
    { value: "native", label: t("common.native"), nativeLabel: t("settings.nativeAutomatic") },
  ];

  return (
    <MediaControl
      source="camera"
      title={t("common.camera")}
      description={t("camera.settingsDescription")}
    >
      <ConfigSection title={t("camera.qualityTitle")} description={t("camera.qualityDescription")}>
        <SegmentedSetting
          title={t("settings.resolution")}
          label={t("settings.cameraResolution")}
          target="cameraResolution"
          options={resolutionOptions}
        />
        <SegmentedSetting
          title={t("settings.frameRate")}
          label={t("settings.cameraFrameRate")}
          target="cameraFps"
          options={FRAME_RATE_VALUES}
        />
      </ConfigSection>
    </MediaControl>
  );
}
